import React from 'react';
import { Icon, Button } from 'semantic-ui-react';
import _ from 'lodash';
import { FieldRow, fieldMatch, norm } from './settings';
import { ruleSummary } from './automation';

// Hesap sayfası genel arama: tüm sekmelerdeki alanlar + otomasyon kuralları + şemada olmayan anahtarlar tek ekranda.
// Alan adı, anahtar, açıklama, eski açıklama, bölüm ve (gizli olmayan) değer içinde aranır.

export default function SearchResults({ query, fields, tabs, getValue, isSet, isChanged, setValue, rules, cronSchema, product, extras, onOpenRule, onOpenTab }) {
	let q = norm(query.trim());

	let ruleHits = [];
	if (cronSchema && !cronSchema.error) {
		_.each(rules || [], (rule, i) => {
			let s = ruleSummary(rule, cronSchema, product);
			if (norm(s.when + ' ' + s.then + ' ' + JSON.stringify(rule)).indexOf(q) !== -1) ruleHits.push({ i, rule, s });
		});
	}

	let groups = _.compact(
		_.map(tabs, (t) => {
			let hits = _.compact(
				_.map(_.filter(fields, { tab: t.key }), (f) => {
					let m = fieldMatch(f, q, getValue(f.path));
					return m ? { f, m } : null;
				})
			);
			return hits.length ? { tab: t, hits } : null;
		})
	);

	let extraHits = _.filter(extras, (path) => norm(path).indexOf(q) !== -1 || norm(JSON.stringify(getValue(path))).indexOf(q) !== -1);
	let total = ruleHits.length + _.sumBy(groups, (g) => g.hits.length) + extraHits.length;

	if (!total)
		return (
			<div className="yta-card">
				<div className="yta-empty">
					<Icon name="search" size="big" />
					<div style={{ marginTop: 8 }}>"{query}" hiçbir ayarda geçmiyor.</div>
				</div>
			</div>
		);

	return (
		<div>
			<div className="yta-muted" style={{ marginBottom: 10 }}>
				"{query}" için {total} sonuç
			</div>

			{ruleHits.length ? (
				<div className="yta-card">
					<div className="yta-card-head">
						<Icon name="clock outline" />
						Otomasyon
						<span className="yta-count">{ruleHits.length}</span>
					</div>
					<div className="yta-card-body">
						{_.map(ruleHits, ({ i, rule, s }) => (
							<div key={i} className="yta-field" style={{ gridTemplateColumns: 'minmax(0, 1fr) auto' }}>
								<div>
									<div className="yta-field-label">
										<span className={'yta-badge' + (rule.active ? ' ok' : '')}>{rule.active ? 'aktif' : 'pasif'}</span>
										<span className="yta-badge">P{rule.priority === undefined ? '?' : rule.priority}</span>
										<span style={{ fontWeight: 400, color: '#6b7280' }}>{s.when}</span> → {s.then}
									</div>
									{s.warnings.length ? <div className="yta-field-desc">{s.warnings.length} uyarı</div> : null}
								</div>
								<Button size="mini" basic content="Otomasyonda aç" onClick={() => onOpenRule(i)} />
							</div>
						))}
					</div>
				</div>
			) : null}

			{_.map(groups, ({ tab, hits }) => (
				<div key={tab.key} className="yta-card">
					<div className="yta-card-head">
						<Icon name={tab.icon} />
						{tab.label}
						<span className="yta-count">{hits.length}</span>
						<div style={{ flex: 1 }} />
						<button className="yta-iconbtn" onClick={() => onOpenTab(tab.key)}>
							Sekmeye git <Icon name="arrow right" />
						</button>
					</div>
					<div className="yta-card-body">
						{_.map(hits, ({ f, m }, idx) => (
							<React.Fragment key={f.path}>
								{!idx || hits[idx - 1].f.section !== f.section ? (
									<div className="yta-col-title" style={{ marginTop: idx ? 14 : 0 }}>
										{f.section}
									</div>
								) : null}
								<FieldRow
									field={f}
									value={getValue(f.path)}
									isSet={isSet(f.path)}
									changed={isChanged(f.path)}
									matchedValue={m === 'value'}
									onChange={(v) => setValue(f.path, v)}
								/>
							</React.Fragment>
						))}
					</div>
				</div>
			))}

			{extraHits.length ? (
				<div className="yta-card">
					<div className="yta-card-head">
						<Icon name="code" />
						Şemada olmayan alanlar
						<span className="yta-count">{extraHits.length}</span>
						<div style={{ flex: 1 }} />
						<button className="yta-iconbtn" onClick={() => onOpenTab('raw')}>
							Ham JSON'a git <Icon name="arrow right" />
						</button>
					</div>
					<div className="yta-card-body">
						{_.map(extraHits, (path) => (
							<div key={path} className="yta-field" style={{ gridTemplateColumns: 'minmax(200px, 38%) minmax(0, 1fr)' }}>
								<div className="yta-field-key" style={{ fontSize: 12 }}>
									{JSON.stringify(path).slice(1, -1)}
								</div>
								<pre className="yta-mono" style={{ margin: 0, maxHeight: 120, overflow: 'auto' }}>
									{_.truncate(JSON.stringify(getValue(path)), { length: 400 })}
								</pre>
							</div>
						))}
					</div>
				</div>
			) : null}
		</div>
	);
}
